(() => {
  const root = document.querySelector('[data-freedom-x-quilt]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = root.querySelectorAll('.qfx-reveal, .qfx-media-reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach((item) => observer.observe(item));
  }

  const form = root.querySelector('[data-quilt-builder]');
  const result = root.querySelector('[data-quilt-result]');
  const paths = {
    1: ['Focused one-room path', 'Start with one QI1-M09-N-NA indoor unit on the QO1-M2Z18-NC-NA platform. A professional confirms the room load and final design.'],
    2: ['Quilt 2-Zone path', 'One QO1-M2Z18-NC-NA outdoor unit supports up to two QI1-M09-N-NA indoor units, subject to partner design and site conditions.'],
    3: ['Quilt 3-Zone path', 'One QO1-M3Z27-NC-NA outdoor unit supports two or three QI1-M09-N-NA indoor units, subject to partner validation.'],
    4: ['Multi-system design path', 'Quilt outdoor units support up to three indoor units. Four or more rooms require professional grouping across multiple systems.']
  };

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const data = new FormData(form);
    const rooms = data.get('rooms');
    const project = data.get('project');
    const zip = String(data.get('zip') || '').trim();
    const path = paths[rooms];
    const audience = project === 'builder'
      ? 'Next step: project specification support for repeatable configurations.'
      : 'Next step: discuss partner availability and an in-home design review.';
    const area = /^\d{5}$/.test(zip)
      ? `Project area: ${zip}. Partner coverage is not checked in this concept experience.`
      : 'Add a five-digit ZIP when live partner routing is available.';
    result.replaceChildren();
    const title = document.createElement('h3');
    title.textContent = path[0];
    const detail = document.createElement('p');
    detail.textContent = path[1];
    const next = document.createElement('p');
    next.textContent = audience;
    const note = document.createElement('small');
    note.textContent = area;
    result.append(title, detail, next, note);
    result.hidden = false;
    result.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
  });
})();
